import * as React from 'react';
import { Crown, Shield, ShieldCheck, User as UserIcon, Briefcase } from 'lucide-react';
import { Badge } from './badge';

export type RoleBadgeRole =
  | 'super_admin'
  | 'admin'
  | 'manager'
  | 'agent'
  | 'user'
  | (string & {});

export interface RoleBadgeProps {
  role: RoleBadgeRole;
  /**
   * Variante semantica del badge:
   * - `tenant`: utente applicativo di un tenant (palette neutra)
   * - `master`: admin del piano di controllo master (ring cyan)
   * Default: `tenant`.
   */
  variant?: 'tenant' | 'master';
  className?: string;
}

const LABELS: Record<string, string> = {
  super_admin: 'Super Admin',
  admin: 'Admin',
  manager: 'Manager',
  agent: 'Agent',
  user: 'User',
};

export const RoleBadge: React.FC<RoleBadgeProps> = ({ role, variant = 'tenant', className }) => {
  const label = LABELS[role] ?? role;
  const accent = variant === 'master' ? 'ring-1 ring-cyan-400/40 dark:ring-cyan-500/40 ' : '';
  const cls = `${accent}${className ?? ''}`.trim();
  switch (role) {
    case 'super_admin':
      return (
        <Badge className={`bg-purple-100 dark:bg-purple-900/30 text-purple-800 dark:text-purple-300 ${cls}`}>
          <Crown className="h-3 w-3 mr-1" />{label}
        </Badge>
      );
    case 'admin':
      return (
        <Badge className={`bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-300 ${cls}`}>
          <ShieldCheck className="h-3 w-3 mr-1" />{label}
        </Badge>
      );
    case 'manager':
      return (
        <Badge className={`bg-cyan-100 dark:bg-cyan-900/30 text-cyan-800 dark:text-cyan-300 ${cls}`}>
          <Briefcase className="h-3 w-3 mr-1" />{label}
        </Badge>
      );
    case 'agent':
      return (
        <Badge className={`bg-orange-100 dark:bg-orange-900/30 text-orange-800 dark:text-orange-300 ${cls}`}>
          <Shield className="h-3 w-3 mr-1" />{label}
        </Badge>
      );
    case 'user':
      return (
        <Badge variant="secondary" className={cls}>
          <UserIcon className="h-3 w-3 mr-1" />{label}
        </Badge>
      );
    default:
      return <Badge variant="outline" className={cls}>{label}</Badge>;
  }
};
